'use client'

import { OpenFeature } from '@openfeature/react-sdk'
import { FliptWebProvider } from '@openfeature/flipt-web-provider'
import config from 'config'
import { capitalizeFirstLetter } from './capitalizeFirstLetter'

let initialized = false

function buildEvaluationContext(identity) {
  return {
    targetingKey:
      identity?.targetingKey ?? identity?.userId?.toString() ?? 'anonymous',
    userId: identity?.userId?.toString(),
    email: identity?.email,
  }
}

export async function initFeatureFlags(identity) {
  if (initialized) {
    if (identity) {
      await OpenFeature.setContext(buildEvaluationContext(identity))
    }
    return
  }

  const provider = new FliptWebProvider(config.FLIPT_NAMESPACE, {
    url: config.FLIPT_URL,
    authentication: config.FLIPT_CLIENT_TOKEN
      ? {
          clientToken: config.FLIPT_CLIENT_TOKEN,
        }
      : undefined,
    environment: capitalizeFirstLetter(config.ENV) || 'Staging',
  })

  await OpenFeature.setProviderAndWait(provider)

  await OpenFeature.setContext(buildEvaluationContext(identity))

  initialized = true
}

export function getFeatureClient() {
  return OpenFeature.getClient()
}
